/**
 * INFRASTRUCTURE — Mapper DTO → dominio (frontera anti-corrupción).
 *
 * Normaliza `channels` y `status` crudos del contrato a los catálogos del dominio:
 * los canales fuera de catálogo se descartan; un `status` desconocido degrada a
 * `desconocido` (nunca rompe la UI). El resto pasa tal cual.
 */
import type {
  Notification,
  NotificationChannel,
  NotificationStatus,
} from './notifications.model';
import type { NotificationListItemDto } from './notifications.dto';

const CHANNELS: ReadonlySet<string> = new Set(['inapp', 'push', 'mail']);
const STATUSES: ReadonlySet<string> = new Set(['pendiente', 'enviada', 'fallida']);

function toChannel(raw: string): NotificationChannel | null {
  return CHANNELS.has(raw) ? (raw as NotificationChannel) : null;
}

function toStatus(raw: string): NotificationStatus {
  return STATUSES.has(raw) ? (raw as NotificationStatus) : 'desconocido';
}

export function toDomainNotification(dto: NotificationListItemDto): Notification {
  return {
    id: dto.id,
    recipientRole: dto.recipientRole,
    eventType: dto.eventType,
    channels: dto.channels
      .map(toChannel)
      .filter((c): c is NotificationChannel => c !== null),
    title: dto.title,
    body: dto.body,
    status: toStatus(dto.status),
    sourceEventId: dto.sourceEventId,
    createdAt: dto.createdAt,
  };
}

export function toDomainNotifications(
  dtos: readonly NotificationListItemDto[],
): Notification[] {
  return dtos.map(toDomainNotification);
}
